import { render, staticRenderFns } from "./InputEditor.vue?vue&type=template&id=8c0bed58&"
import script from "./InputEditor.vue?vue&type=script&lang=js&"
export * from "./InputEditor.vue?vue&type=script&lang=js&"
import style0 from "./InputEditor.vue?vue&type=style&index=0&id=8c0bed58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports